import { handleResponse, restartUserSession, authHeader } from '../helpers'

export const membersCleanupService = {
    load,
    remove,
}

function load () {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    }
    return fetch(`/members-cleanup`, requestOptions).then(handleResponse)
}

function remove () {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    }
    return fetch(`/members-cleanup`, requestOptions).then(handleResponse)
}
